import { Link } from 'react-router-dom';
import { TypoFootnote } from '@/components/Typography.tsx';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#422933] shrink-0 p-4">
      <div
        className="w-full max-w-5xl mx-auto flex flex-col-reverse
        md:flex-row items-center justify-between md:h-16 gap-4"
      >
        <TypoFootnote className="text-[#D3B6AD] text-center md:text-left md:max-w-[30rem]">
          Copyright © {year} SATPrac. All rights reserved.
          <br />
          SAT® are trademarks registered by the College Board,
          which is not affiliated with, and does not endorse, this product.
        </TypoFootnote>
        <div className="flex justify-end gap-4 text-[#D3B6AD] min-w-0 shrink-0 m:flex-wrap m:gap-x-4 m:gap-y-1">
          <Link className="hover:underline m:inline-flex m:min-h-11 m:items-center" to="/terms">
            Terms
          </Link>
          <Link className="hover:underline m:inline-flex m:min-h-11 m:items-center" to="/privacy-policy">
            Privacy Policy
          </Link>
          <a
            className="hover:underline m:inline-flex m:min-h-11 m:items-center"
            href="https://idiottutor.com/"
            target="_blank"
          >
            Idiot Tutor Mark on TikTok
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
